export default {"src":"/_next/static/media/consent-capture-and-store.42ba336a.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};